import Store from 'store/store';
import { joinPaths } from 'utils/utils';

const defaultPathsPerPage = { showtimes: '/tickets/', homeEnt: '/home-ent/' };
function pagePath(page, item, status) {
	// if (item.url) return '/';
	return status[`${page}Path`] || defaultPathsPerPage[page] || '/';
}
function getMovieLink(item, status, page = '') {
	// Should we use an absolute URL for /movies/?
	const base = item.url || (item?.slug ? `/movies/${item.slug}/` : null);
	if (!base) return null;
	return joinPaths(base, pagePath(page, item, status));
}

function override(base, overrides, type) {
	let label = overrides?.[`${type}ButtonText`];
	if (label && !base) base = { type };
	if (label) base.label = label;

	if (!base) return null;

	let destination = overrides?.[`${type}ButtonLink`];
	if (destination) base.destination = destination;

	return base;
}

// Logic based on https://app.asana.com/1/8582257821148/task/1209230932412062?focus=true
export function getButtons(movie, overrides) {
	const status = Store.get().movieStatuses?.[movie?.id];
	if (!status) return [];
	let defaultPrimaryButton;
	let defaultSecondaryButton;
	const trailer = Object.values(movie?.trailers || {}).find(trailer => trailer?.url);
	if (trailer) {
		defaultSecondaryButton = { label: 'Watch trailer', destination: trailer.url, type: 'secondary' };
	}
	if (status?.theaters === 'comingSoon') {
		defaultPrimaryButton = { label: 'Learn more', destination: getMovieLink(movie, status), type: 'primary' };
	} else if (status?.theaters === 'preSale' || status?.theaters === 'inTheaters') {
		defaultPrimaryButton = { label: 'Get tickets', destination: getMovieLink(movie, status, 'showtimes'), type: 'primary' };
	} else if (status?.homeEnt === 'homeEnt') {
		defaultPrimaryButton = { label: 'Watch at Home', destination: getMovieLink(movie, status, 'homeEnt'), type: 'primary' };
	}
	if (status?.theaters === 'inTheaters' && status?.homeEnt === 'homeEnt') {
		defaultSecondaryButton = { label: 'Watch at Home', destination: getMovieLink(movie, status, 'homeEnt'), type: 'secondary' };
	}

	if (!defaultSecondaryButton && defaultPrimaryButton?.label !== 'Learn more') {
		defaultSecondaryButton = { label: 'Learn more', destination: getMovieLink(movie, status), type: 'secondary' };
	}
	return [
		override(defaultPrimaryButton, overrides, 'primary'),
		override(defaultSecondaryButton, overrides, 'secondary'),
	].filter(Boolean);
}